// extracted by mini-css-extract-plugin
module.exports = {"root":"Winner-root-2fVMQ","text":"Winner-text-2NeHI","input":"Winner-input-3FBe6","button":"Winner-button-3YIjF"};